import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from "react-router-dom"
import Home from "./pages/Home"
import Signin from "./pages/Signin"
import Join from "./pages/Join"
import Dashboard from "./pages/Dashboard"
import Profile from "./pages/Profile"
import About from "./pages/About"
import Contact from "./pages/Contact"
import Faq from "./pages/Faq"
import FourZeroFour from "./pages/FourZeroFour"
import Conversation from "./components/conversation/Conversation"
import EventPage from "./components/event/ListEvents"
import Terms from "./pages/Terms"
import Privacy from "./pages/Privacy"
import NewEvent from "./components/event/NewEvent"
import PendingEvents from "./components/event/PendingEvents"
import UpdateEvent from "./components/event/EventUpdate"
import Create from "./components/conversation/ConversationCreate"
import Delete from "./components/conversation/ConversationDelete"
import Edit from "./components/conversation/ConversationEdit"
import Layout from "./components/layout/Layout"
import Admin from "./pages/Admin"
import CategoryList from "./components/category/CategoryList"

// New route
import CompanyPage from "./components/company/CompanyPage"
import SearchResults from "./components/company/SearchPage"
import SupplierProfile from "./pages/SupplierProfile"

import { profileRoutes } from "./lib/bandung/components/Profile/ProfileComponent"
import { signinComponentLoader } from "./lib/bandung/components/Signin/SigninComponent"
import { adminRoutes } from "./lib/bandung/components/Admin/AdminComponent"
import { contactLoader, testAdminLoader } from "./components/contact/contactLoader"
import { contactCreateAction } from "./components/contact/contactActions"
import { dashboardRoutes } from "./components/dashboard/DashboardComponent"
import {
  conversationCreateAction,
  conversationUpdateAction,
  conversationDeleteAction,
} from "./components/conversation/conversationActions"
import {
  conversationDetailLoader,
  conversationListLoader,
  conversationLoader,
} from "./components/conversation/conversationLoader"
import ConversationDetail from "./components/conversation/ConversationDetail"
import {
  eventLoader,
  pendingEventLoaders,
  previousEventLoader,
  upcomingEventLoaders,
} from "./components/event/eventLoaders"
import { eventCreateAction, eventUpdateAction } from "./components/event/eventActions"
import SupplierDashboard from "./pages/SupplierDashboard"
import SupplierCreateNewProduct from "./pages/SupplierCreateNewProduct"
import ProductDetails from "./pages/ProductDetails"

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<Layout />}>
      <Route index element={<Home />} />
      <Route path="signin" element={<Signin />} loader={signinComponentLoader} />
      <Route path="join" element={<Join />} />
      <Route path="dashboard" element={<Dashboard />}>
        {dashboardRoutes}
      </Route>
      <Route path="profile" element={<Profile />}>
        {profileRoutes}
      </Route>
      <Route path="admin" element={<Admin />}>
        {adminRoutes}
      </Route>
      <Route path="about" element={<About />} />
      <Route path="conversation">
        <Route index element={<Conversation />} loader={conversationListLoader} />
        <Route path=":conversationEntityId" element={<ConversationDetail />} loader={conversationDetailLoader} />
        <Route path="create" element={<Create />} action={conversationCreateAction} loader={testAdminLoader} />
        <Route path="delete" element={<Delete />} action={conversationDeleteAction} loader={conversationLoader} />
        <Route path="edit" element={<Edit />} action={conversationUpdateAction} loader={conversationLoader} />
      </Route>
      <Route id="contact" path="contact" element={<Contact />} action={contactCreateAction} loader={contactLoader} />
      <Route id="faq" path="faq" element={<Faq />} action={contactCreateAction} loader={contactLoader} />
      {/* <Route
        id="form"
        path="form"
        element={<Form />}
        action={contactCreateAction}
        loader={contactLoader}
      /> */}

      {/* Category path */}
      <Route path="category" element={<CategoryList />} />
      <Route path="category/:type" element={<CategoryList />} />


      {/* TEMPORARY PATH */}
      <Route
        id="searchResults"
        path="searchResults"
        element={<SearchResults />}
        action={contactCreateAction}
        loader={contactLoader}
      />

      <Route
        id="companyName"
        path="companyName"
        element={<CompanyPage />}
        action={contactCreateAction}
        loader={contactLoader}
      />

      <Route id="supplierProfile" path="supplier/:id" element={<SupplierProfile />} />

      <Route path="terms" element={<Terms />} />
      <Route path="privacy" element={<Privacy />} />
      <Route path="event">
        <Route index element={<EventPage />} loader={upcomingEventLoaders} />
        <Route path="previous" element={<EventPage />} loader={previousEventLoader} />
        <Route path="new" element={<NewEvent />} action={eventCreateAction} loader={conversationListLoader} />
        <Route path="update/:id" element={<UpdateEvent />} loader={eventLoader} action={eventUpdateAction} />
        <Route path="pending" element={<PendingEvents />} loader={pendingEventLoaders} />
      </Route>
      <Route exact path="*" element={<FourZeroFour />} />

      <Route id="supplierDashboard" path="SupplierDashboard" element={<SupplierDashboard />} />
      <Route id="supplierCreateNewListing" path="createNewListing" element={<SupplierCreateNewProduct />} />

      <Route id="productDetails" path="productDetails" element={<ProductDetails />} />

    </Route>,
  ),
)

export default function Router() {
  return <RouterProvider router={router} />
}
